<section class="dept" aria-label="Customer heading">
  <p class="customer-heading" data-testid="customer-heading">
    @if (user.course_title) {
      <span class="course-title">{{ user.course_title }}</span>
      <span class="customer-name customer-name--secondary">{{ user.customer_name }}</span>
    } @else {
      <span class="customer-name">{{ user.customer_name }}</span>
    }
  </p>
</section>
